module.exports = __webpack_public_path__ + "static/faq-ca51f6a44da8752f00830ad4814ddd24.pdf";